import axios from "axios";
import authUtil from "../utils/AuthUtils";
import { getCurrentUserEmail } from "../utils/user";
import { getServiceApiKey } from "../utils/apiKey";

const BASE_API_URL = `${window?.appConfig?.API_ENDPOINT}`;

// Helper function to create config
const getConfig = async () => {
  const token = await authUtil.getDocumentServiceToken();
  return {
    headers: {
      "x-api-key": getServiceApiKey(),
      "x-document-service-integration-token": token,
    },
  };
};

async function createClient(clientData) {
    const config = await getConfig();
    const userName = getCurrentUserEmail();
    const requestData = {
        ...clientData,
        createdBy: userName
    };
    return axios.post(BASE_API_URL + `/admin/client`, requestData, config);
}

async function viewClients() {
    const config = await getConfig();
    return axios.get(BASE_API_URL + `/admin/clients`, config);
}

async function generateClientCredentials(clientName, recreateCredentials = true) {
    const config = await getConfig();
    const userName = getCurrentUserEmail();
    const requestData = {
        updatedBy: userName,
        updatedAt: new Date().toISOString()
    };
    const endpoint = BASE_API_URL + `/admin/generate/credentials/${encodeURIComponent(clientName)}?recreateClientCredentials=${recreateCredentials}`;
    return axios.post(endpoint, requestData, config);
}

async function updateApiKeyState(clientName, requestBody) {
    const config = await getConfig();
    const userName = getCurrentUserEmail();
    const requestData = {
        apiKey: requestBody.apiKey,
        setState: requestBody.setState,
        updatedBy: userName,
        updatedAt: new Date().toISOString()
    };
    const endpoint = `${BASE_API_URL}/admin/client/${encodeURIComponent(clientName)}/apikey/state`;
    return axios.post(endpoint, requestData, config);
}

async function createApiKey(clientName) {
    const config = await getConfig();
    const userName = getCurrentUserEmail();
    const requestData = {
        createdBy: userName,
        updatedBy: userName,
        updatedAt: new Date().toISOString()
    };
    const endpoint = `${BASE_API_URL}/admin/client/${encodeURIComponent(clientName)}/apikey`;
    return axios.post(endpoint, requestData, config);
}

async function updateClient(clientName, clientData) {
    const config = await getConfig();
    const userName = getCurrentUserEmail();
    const requestData = {
        ...clientData,
        updatedBy: userName,
        updatedAt: new Date().toISOString()
    };
    const endpoint = `${BASE_API_URL}/admin/client/${encodeURIComponent(clientName)}`;
    return axios.post(endpoint, requestData, config);
}

async function getAllApiKeysForClient(clientName) {
    const config = await getConfig();
    const endpoint = `${BASE_API_URL}/admin/client/${encodeURIComponent(clientName)}/apikeys`;
    return axios.get(endpoint, config);
}

async function updateAllClientsSettings(clientData, queryParams = {}) {
    const config = await getConfig();
    const userName = getCurrentUserEmail();
    const requestData = {
        ...clientData,
        updatedBy: userName,
        updatedAt: new Date().toISOString()
    };
    const endpoint = `${BASE_API_URL}/admin/clients/settings`;
    const queryString = Object.keys(queryParams)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
        .join('&');
    const fullEndpoint = queryString ? `${endpoint}?${queryString}` : endpoint;   
    return axios.post(fullEndpoint, requestData, config);
}

export default {
    createClient,
    viewClients,
    generateClientCredentials,
    updateApiKeyState,
    createApiKey,
    updateClient,
    getAllApiKeysForClient,
    updateAllClientsSettings
};
